import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import HittaLogo from '../common/HittaLogo/HittaLogo';
import routeConstants from '../../Routes/routeConstants';
import trackingUtils from '../../utils/trackingUtils';
import translationPropType from '../../proptypes/translationPropType';

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    logo: {
        margin: theme.spacing(2),
    },
    appNameWrapper: {
        display: 'flex',
    },
    nextSeparator: {
        fontWeight: 200,
    },
    next: {
        fontWeight: 200,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    submit: {
        marginTop: theme.spacing(3),
    },
});

const LoginWrapper = ({
    classes,
    translation,
    location,
    loggedIn,
    loggingIn,
    refreshing,
    handleLogin,
    handleLoggedIn,
}) => {
    const { from } = location.state ?? {};

    const searchQuery = React.useMemo(() => new URLSearchParams(location.search, [location.search]));
    if (searchQuery.get("token")) {
        handleLoggedIn(searchQuery.get("token"));
    }

    const loginRedirect = (!from || from.pathname === routeConstants.LOGIN) ? routeConstants.COMPANY_REPORT : from;
    useEffect(() => {
        trackingUtils.trackPageview(routeConstants.LOGIN);
    }, []);

    useEffect(() => {
        document.title = translation.LOGIN_PAGE_TITLE;
    }, [translation]);

    return (
        <main className={classes.main}>
            { loggedIn && (
                <Redirect to={loginRedirect} />
            )
            }
            { !refreshing && (
                <Paper className={classes.paper}>
                    <HittaLogo classes={classes.logo} size={100} />
                    <div className={classes.appNameWrapper}>
                        <Typography variant="h5" noWrap>
                            {translation.STATISTICS}
                        </Typography>
                        <Typography className={classes.nextSeparator} variant="h5" color="primary" noWrap>
                                |
                        </Typography>
                        <Typography className={classes.next} variant="h5" color="textSecondary" noWrap>
                            {translation.SYSTEM.toLowerCase()}
                        </Typography>
                    </div>
                    <Button
                        fullWidth
                        variant="contained"
                        disabled={loggingIn}
                        color="primary"
                        className={classes.submit}
                        onClick={() => handleLogin()}
                    >
                        {translation.LOG_IN}
                    </Button>
                </Paper>
            )}
        </main>
    );
};

LoginWrapper.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: translationPropType.isRequired,
    location: ReactRouterPropTypes.location.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    handleLoggedIn: PropTypes.func.isRequired,
    loggingIn: PropTypes.bool.isRequired,
    loginFailed: PropTypes.bool.isRequired,
    refreshing: PropTypes.bool.isRequired,
};

export default withStyles(styles)(LoginWrapper);
